import { render, staticRenderFns } from "./EditarPerfilPermisos.vue?vue&type=template&id=efbdeb5a&scoped=true"
import script from "./EditarPerfilPermisos.vue?vue&type=script&lang=js"
export * from "./EditarPerfilPermisos.vue?vue&type=script&lang=js"
import style0 from "./EditarPerfilPermisos.vue?vue&type=style&index=0&id=efbdeb5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efbdeb5a",
  null
  
)

export default component.exports